import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-midnight border-t border-white/5 py-8 px-6" data-id="element-16">
        <div className="max-w-2xl mx-auto flex flex-col items-center gap-4 text-center" data-id="element-17">
          <p className="text-warmgray/40 text-sm" data-id="element-18">
            © {new Date().getFullYear()} Reset 3AM. Todos los derechos
            reservados.
          </p>
          <p className="text-warmgray/30 text-xs" data-id="element-19">
            Este producto no sustituye consejo médico profesional.
          </p>
          <div className="flex items-center gap-6 mt-2" data-id="element-20">
            <button onClick={() => setPrivacyOpen(true)} className="text-warmgray/50 hover:text-amber text-xs uppercase tracking-widest transition-colors" data-id="element-21">
              Política de Privacidad
            </button>
            <span className="text-warmgray/20" data-id="element-22">·</span>
            <button onClick={() => setTermsOpen(true)} className="text-warmgray/50 hover:text-amber text-xs uppercase tracking-widest transition-colors" data-id="element-23">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-24">
        <p className="text-warmgray text-xs mb-4" data-id="element-25">
          Última actualización: febrero 2026
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-26">
          1. Información que recopilamos
        </h3>
        <p data-id="element-27">
          Al adquirir Reset 3AM, recopilamos únicamente la información necesaria
          para procesar tu compra: nombre, dirección de correo electrónico y
          datos de pago. No almacenamos datos de tarjeta de crédito
          directamente; estos son procesados de forma segura por nuestro
          proveedor de pagos.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-28">
          2. Uso de la información
        </h3>
        <p data-id="element-29">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2 text-warmgray" data-id="element-30">
          <li data-id="element-31">Entregar el producto digital adquirido</li>
          <li data-id="element-32">Enviar comunicaciones relacionadas con tu compra</li>
          <li data-id="element-33">Proporcionar soporte si lo solicitas</li>
        </ul>
        <p className="mt-2" data-id="element-34">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros con fines de marketing.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-35">
          3. Cookies y seguimiento
        </h3>
        <p data-id="element-36">
          Este sitio puede utilizar cookies esenciales para el funcionamiento
          básico y cookies analíticas anónimas para mejorar la experiencia. No
          utilizamos cookies de seguimiento publicitario.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-37">
          4. Protección de datos
        </h3>
        <p data-id="element-38">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal. Sin embargo, ningún método de transmisión por
          internet es 100% seguro.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-39">
          5. Tus derechos
        </h3>
        <p data-id="element-40">
          Puedes solicitar acceso, corrección o eliminación de tus datos
          personales en cualquier momento enviando una solicitud a través de
          nuestros canales de comunicación.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-41">
          6. Cambios a esta política
        </h3>
        <p data-id="element-42">
          Nos reservamos el derecho de actualizar esta política. Cualquier
          cambio será publicado en esta página con la fecha de actualización
          correspondiente.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-43">
        <p className="text-warmgray text-xs mb-4" data-id="element-44">
          Última actualización: febrero 2026
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-45">
          1. Producto digital
        </h3>
        <p data-id="element-46">
          Reset 3AM es un producto digital (PDF) de carácter informativo y
          educativo. Al realizar la compra, recibirás acceso inmediato al
          material descargable. Este producto es para uso personal y no puede
          ser redistribuido, revendido ni compartido.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-47">
          2. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-48">
          Reset 3AM{' '}
          <strong className="text-cream" data-id="element-49">
            no es un sustituto de consejo médico, diagnóstico o tratamiento
            profesional.
          </strong>{' '}
          El contenido tiene fines informativos y educativos únicamente. Si
          experimentas problemas de sueño crónicos, ansiedad severa, o sospechas
          de condiciones como apnea del sueño, consulta con un profesional de la
          salud.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-50">
          3. Política de reembolso
        </h3>
        <p data-id="element-51">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Si experimentas problemas técnicos con
          la descarga, contáctanos y te ayudaremos a resolverlo.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-52">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-53">
          Todo el contenido de Reset 3AM, incluyendo textos, diseños, plantillas
          y materiales complementarios, está protegido por derechos de autor.
          Queda prohibida su reproducción, distribución o modificación sin
          autorización expresa.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-54">
          5. Resultados
        </h3>
        <p data-id="element-55">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que la efectividad depende de múltiples
          factores individuales, incluyendo la consistencia en la aplicación del
          protocolo.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-56">
          6. Modificaciones
        </h3>
        <p data-id="element-57">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en esta página.
        </p>

        <h3 className="text-cream font-heading text-base mb-2" data-id="element-58">
          7. Ley aplicable
        </h3>
        <p data-id="element-59">
          Estos términos se rigen por las leyes aplicables en la jurisdicción
          correspondiente. Cualquier disputa será resuelta de acuerdo con dichas
          leyes.
        </p>
      </LegalModal>
    </>;
}